import { ButtonComponent } from '@/components/commons'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'
import { cssClass } from '@/shared/utils'
import {
  emptyStateImage,
  notificationHeaderBackground,
} from 'containers/highlights/styles/highlight.css'
import Image from 'next/image'
import Link from 'next/link'

interface HighlightEmptyStateProps {
  onAddHighlight: () => void
  className?: string
}

export const HighlightEmptyState = ({
  onAddHighlight,
  className,
}: HighlightEmptyStateProps) => {
  return (
    <div className={className}>
      <div
        className={cssClass([
          'py-12 px-24 rounded-t-12',
          notificationHeaderBackground,
        ])}
      >
        <Title variation="small" colorClass="text-accent-primary">
          Creatorland Highlights
        </Title>
      </div>
      <div className="p-24 bg-white-primary rounded-b-12">
        <Title sizeClass="text-20--tablet text-18">
          Elevate Your Profile with Highlights!
        </Title>

        <Text
          colorClass="text-secondary"
          sizeClass="text-14--tablet text-12"
          className="mt-8"
        >
          Showcase your standout moments in a snap with Highlights. Perfect for
          brand collabs, viral hits, or portfolio snippets, these concise
          showcases let you display your top achievements effectively, making
          them easily discoverable and shareable.
        </Text>

        <Text
          colorClass="text-primary"
          sizeClass="text-14--tablet text-12"
          className="mt-16"
        >
          <Link
            href="https://help.creatorland.com/hc/en-us/articles/20581112566043-Where-to-find-and-edit-your-Highlights"
            target="_blank"
            className="text-info"
          >
            Learn more about Highlights in our help center.
          </Link>
        </Text>

        <div className="mt-32--tablet mt-22 flex justify-center">
          <div className={cssClass(['relative', emptyStateImage])}>
            <Image
              src={IMAGE_PATHS_V2.profileV2 + 'bg_empty_highlights-2.png'}
              alt="Empty Highlights - invite to create highlights"
              fill
              style={{
                objectFit: 'contain',
              }}
              sizes="(max-width: 592px) 90vw, 546px"
            />
          </div>
        </div>

        <div className="flex items-center justify-center mt-32">
          <ButtonComponent
            variation="primary"
            size="small"
            className="productFruits-highlights-tour"
            label="Create your first highlight"
            onClick={onAddHighlight}
          />
        </div>
      </div>
    </div>
  )
}
